import ProcessIMG1 from  '../../../assets/images/nas-process-1.png'
import ProcessIMG2 from  '../../../assets/images/nas-process-2.png'
import ProcessIMG3 from  '../../../assets/images/nas-process-3.png'
import ProcessIMG4 from  '../../../assets/images/nas-process-4.png'
import ProcessIMG5 from  '../../../assets/images/nas-process-5.png'
import ProcessMobile1 from '../../../assets/images/itm01.png';
import ProcessMobile2 from '../../../assets/images/itm02.png';
import ProcessMobile3 from '../../../assets/images/itm03.png';
import ProcessMobile4 from '../../../assets/images/itm04.png';
import ProcessMobile5 from '../../../assets/images/itm05.png';

import { Service } from './types';

export const services: Service[] = [
  {
    id: 1,
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    alt: 'IT Monleys NAS Synology',
    title: 'I. Audit et sélection du matériel',
    description: 'Nous étudions votre environnement informatique actuel, vos besoins de stockage et vos impératifs de sécurité.',
    link: '/#',
    features: [
      { text: '' },
      { text: "Prise d'informations et objectifs." },
      { text: 'Analyse de votre environnement informatique.' },
      { text: 'Sélection du matériel adapté.' },
    ],
  },
  {
    id: 2,
    icon: ProcessMobile2,
    mobileIcon: ProcessMobile2,
    alt: 'Cybersecurity Icon',
    title: 'II. Installation et configuration',
    description: 'Déploiement des équipements dans vos locaux ou dans notre datacenter.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Configuration des connexions sécurisées.' },
      { text: 'Paramétrage du NAS et sécurité.' },
      { text: 'Tests de performances et fiabilité.' },
    ],
  },
  {
    id: 3,
    icon: ProcessMobile3,
    mobileIcon: ProcessMobile3,
    alt: 'Cloud Service Icon',
    title: 'III. Migration et intégration',
    description: 'Planification d\'une feuille de route pour déplacer vos données sans perturber votre activité.',
    link: '/#',
    features: [
      { text: '' },
      { text: "Plan d'action pour transfert." },
      { text: 'Copie et synchronisations chifrées.' },
      { text: 'Intégration des logiciels métiers.' }
    ],
  },
  {
    id: 4,
    icon: ProcessMobile4,
    mobileIcon: ProcessMobile4,
    alt: 'OpenAI Icon',
    title: 'IV. Administration et maintenance',
    description: 'Surveillance et suivi continu de l\'état de santé du NAS, de ses performances et de son utilisation.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Mises à jour et correctifs.' },
      { text: 'Analyse et intervention préventive.' },
      { text: 'Ajustement des ressources optimales.' },

    ],
  },
  {
    id: 5,
    icon: ProcessMobile5,
    mobileIcon: ProcessMobile5,
    alt: 'Training Icon',
    title: 'V. Support et accompagnement',
    description: 'Notre équipe est disponible pour répondre à vos questions, traiter les incidents et vous accompagner au quotidien.',
    link: '/training',
    features: [
      { text: '' },
      { text: 'Conseil et aide pour NAS.' },
      { text: 'Ajout/remplacement de disques.' },
      { text: 'Intégration de nouveaux services.' },
    ],
  },
];
